import axios from "axios";

export const axiosInstance = axios.create();

if (process.env.REACT_APP_BACKEND_MODE === "PROD") {
  axiosInstance.defaults.baseURL = process.env.REACT_APP_API_PROD;
} else {
  axiosInstance.defaults.baseURL = process.env.REACT_APP_API_LOCAL;
}

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong"
    )
);

export const endpoint = {

  auth: {
    login: "/login",
    logout: "/logout"
  },

  forgotPin: {
    requestOtp: "/request-otp",
    updatePin: "/update-pin"
  },

  Dashboard: {
    static: "/dashboard"
  },

  Profile: {
    DetailUser: "/user",
    UpdateProfile: "/update-profile"
  },

  Service: {
    ServiceList: "/services/get-all",
    ServiceAdd:"/services/insert",
    ServiceDetail:"/services/detail"
  },

  MasterDataService: {
    Color: "/color/get-all",
    Storage: "/device/storage/get-all",
    Customer: "/customer/get-all",
    DeviceMerk: "/device/brand/get-all",
    MyDevice: "/device/my-device/get-all",
    TemplateDevice: "/device/template/get-all",
    DeviceKategori: "/device/category/get-all"
  },
  Customer:{
    AddCustomer: "/customer/store"
  },
  Receive:{
    ReceiveList: "/item/transfer/get-all",
     ReceiveDetailList: "/item/transfer/detail"
  }
};